var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    viewBox: "0 0 60 60",
    overflow: "visible"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 60C13.5 60 0 46.5 0 30S13.5 0 30 0s30 13.5 30 30-13.5 30-30 30zm0-57C15.1 3 3 15.1 3 30s12.1 27 27 27 27-12.1 27-27S44.9 3 30 3zm0 35.6a1.54 1.54 0 0 1-1.5-1.5c0-5.5 3.4-7.5 6.1-9.1 2.6-1.5 4.6-2.7 4.6-6.5 0-5.4-4.8-7.9-9.2-7.9s-9.2 2.5-9.2 7.9a1.54 1.54 0 0 1-1.5 1.5 1.54 1.54 0 0 1-1.5-1.5c0-7.1 6.1-10.8 12.2-10.8 3.1 0 6.1.9 8.3 2.7 2.6 2 3.9 4.8 3.9 8.2 0 5.5-3.4 7.5-6.1 9.1-2.6 1.5-4.6 2.7-4.6 6.5 0 .7-.7 1.4-1.5 1.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 46,
    r: 1.8
  })));
};
export default SvgQuestionMark;